<spike-base-page [breadcrumbItems]="breadcrumb" [title]="title()">
    
    <div actions>
        <p-button (click)="openTradeInDialog()" class="mr-2" label="Entrata" icon="pi pi-arrow-up"></p-button>
        <p-button (click)="openTradeOutDialog()" class="mr-2" label="Uscita" icon="pi pi-arrow-down"></p-button>
        <p-button (click)="openAccountTransferDialog()" label="Giroconto" icon="pi pi-arrow-right-arrow-left"></p-button>
    </div>

     <div header>
        <div class="flex w-full items-end gap-4 mb-4">
            <div class="flex-1">
                <spike-trade-filters-form [(filter)]="searchFilter"></spike-trade-filters-form>
            </div>
        </div>
    </div>
    @if (trades() && trades().list && trades().list.length > 0) {
        <div class="spike-table-card">
            <spike-trades-table 
                [items]="trades().list" 
                [(sorting)]="sorting"
                (onSelect)="openTradeDialog($event)" />
                <p-paginator 
                    (onPageChange)="onPageChange($event)" 
                    [first]="pagination().first" 
                    [rows]="pagination().rows" 
                    [totalRecords]="trades().totalCount" 
                    [rowsPerPageOptions]="this.pagination().rowsPerPageOptions" />

        </div> 
    }@else {
        <spike-no-result 
            title="Nessuna operazione trovata"
            description="Non hai ancora aggiunto operazioni" 
            icon="pi pi-filter">
        </spike-no-result>
    }
</spike-base-page>

@if(isSidepanelTradeVisibile()){
    <spike-trade-side-panel 
        [(isDialogVisible)]="isSidepanelTradeVisibile"
        [data]="selectedTrade()"
        [finTradeTypeId] = "finTradeTypeId()"
        (onSave)="onSave()"
        (onClose)="closeSidePanel()"
        (onDelete)="onDelete()"/>
}

@if(isSidepanelAccountTransferVisibile()){
    <spike-account-transfer-side-panel 
        [(isDialogVisible)]="isSidepanelAccountTransferVisibile"
        (onSave)="onSave()"
        (onClose)="closeSidePanel()"/>
}
